module.exports = __webpack_public_path__ + "img/10.84b386b3.svg";